require('./overrides.scss')

export default {
  theme: {
    themes: {
      light: {
        primary: '#9155FD',
        accent: '#0d6efd',
        secondary: '#8A8D93',
        success: '#4AAD1D',
        info: '#16B1FF',
        warning: '#FFB400',
        error: '#ab4d4e',
      },
      dark: {
        primary: '#9155FD',
        accent: '#0d6efd',
        secondary: '#8A8D93',
        success: '#4AAD1D',
        info: '#16B1FF',
        warning: '#FFB400',
        error: '#ab4d4e',
      },
    },
  },
}
